export default __webpack_public_path__ + "static/media/coin-1.8ac56c8c.png";